import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base';
import Utils from '../js/utils';
export default (function (props, _ref) {
  var $ = _ref.$,
      $update = _ref.$update,
      $f7 = _ref.$f7;
  var page_name = 'baocao-eod-chitiet';
  var loai = {
    chuyen_khoan: 'Chuyển khoản',
    quet_the: 'Quẹt thẻ',
    chi_phi: 'Chi phí'
  };
  var rows, photoBrowser;

  _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var rs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Base.call({
              method: '_get',
              table: 'baocao_cuoingay_chitiet',
              params: {
                where: 'id_baocao=:id AND loai = :loai AND deleted_at IS NULL',
                where_data: {
                  id: parseInt(props.row.id),
                  loai: props.loai
                }
              }
            });

          case 2:
            rs = _context.sent;

            if (!(rs.rows.length === 0)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            rows = rs.rows;
            $update();

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))();

  var zoomIn = function zoomIn(e) {
    var src = $(e.target).attr("src");
    $f7.photoBrowser.create({
      photos: [src]
    }).open();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="popup ${page_name}" data-name="${page_name}">
    <div class="view">
      <div class="navbar">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <div class="title">Danh sách ${loai[props.loai]}</div>
          <div class="right">
            <a href="#" class="link popup-close" data-popup=".${page_name}"><i class="icon f7-icons">multiply</i></a>
          </div>
        </div>
      </div>
      <div class="page">
        <div class="page-content">

          <div class="block text-align-center">
            <h3 class="text-color-orange">Tổng: ${Utils.num2Str(props.row[props.loai]*1000)}</h3>
          </div>
    
          <div class="block-title">Bảng kê chi tiết</div>

          <div class="card data-table margin-half">
            <table>
              <thead>
                <tr>
                  <th class="numeric-cell">Số tiền</th>
                  <th>Ảnh/Mô tả</th>
                </tr>
              </thead>
              <tbody>
                ${rows && rows.map(row=>$h`
                  <tr>
                    <td class="numeric-cell">${Utils.num2Str(row.so_tien*1000)}</td>
                    <td>
                      <div>
                        ${row.anh_chup && $h`<img @click="${zoomIn}" src="${Base.uploadURL}/bills/${row.anh_chup}" style="height: 200px;"/>`}
                      </div>
                      <div>${row.mo_ta || ''}</div>
                    </td>
                  </tr>
                `)}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
`
    }
    ;
});